var rich_content_viewer_default = {
  "fontElementMap": "ZnMEC",
  "wrapper": "zrLtk",
  "pluginContainerMobile": "pY8WU",
  "viewer": "tlZw8",
  "android": "YHur4",
  "rootedTraversedContent": "_7UvJA",
  "atomic": "_8B4zb",
  "toolbar": "DjL2Y",
  "block": "b8HqH"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
